import React from "react";
import { hydrate } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { HelmetProvider } from "react-helmet-async";

import Router from "../universal/routes";
import createReduxStore from "../universal/createReduxStore";
import { restoreCartFromCookieStorage } from "./../redux/reducers/utils/cart";
import { ADMIN_THEME_COOKIE, createAppTheme, DEFAULT_THEME_MODE } from "./../universal/theme";
import { ThemeModeContext } from "../universal/ThemeModeContext";

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__ || { catalogReducer: {} }; // eslint-disable-line no-underscore-dangle
delete preloadedState.__adminThemeMode;

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__; // eslint-disable-line no-underscore-dangle

// Ugly hack but will do for now
preloadedState.catalogReducer.cart = restoreCartFromCookieStorage();

// Create Redux store with initial state
const store = createReduxStore({ preloadedState });

function setCookie(name, value, days) {
  try {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value || "") + expires + "; path=/";
  } catch (e) {
    // best-effort
  }
}

function Main() {
  const initialMode =
    (window && window.__ADMIN_THEME__ === "dark" ? "dark" : DEFAULT_THEME_MODE) ||
    DEFAULT_THEME_MODE;

  const [mode, setMode] = React.useState(initialMode);
  const theme = React.useMemo(() => createAppTheme(mode), [mode]);

  const toggleMode = React.useCallback(() => {
    setMode((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      setCookie(ADMIN_THEME_COOKIE, next, 365);
      return next;
    });
  }, []);

  React.useEffect(() => {
    if (document) {
      const jssStyles = document.querySelector("#jss-server-side");
      if (jssStyles) {
        jssStyles.parentElement.removeChild(jssStyles);
      }
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HelmetProvider>
        <Provider store={store}>
          <ThemeModeContext.Provider value={{ mode, setMode, toggleMode }}>
            <BrowserRouter>
              <Router />
            </BrowserRouter>
          </ThemeModeContext.Provider>
        </Provider>
      </HelmetProvider>
    </ThemeProvider>
  );
}

if (document){
  hydrate(<Main />, document.querySelector("#root"));
} 
